var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      staticClass: "yxtbiz-hwk-template-selector",
      attrs: {
        visible: _vm.visible,
        "before-close": _vm.beforeClose,
        size: "960px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        closed: _vm.handleClose,
      },
    },
    [
      _c("template", { slot: "title" }, [
        _c("span", { staticClass: "yxtbiz-hwk-template-selector__title" }, [
          _vm._v(
            _vm._s(_vm.$t("pc_biz_appraise_choose_template").d("选择模板"))
          ),
        ]),
        _c("span", { staticClass: "yxtbiz-hwk-template-selector__describe" }, [
          _vm._v(
            _vm._s(
              _vm
                .$t("pc_biz_lbl_select_edit_content_template_operate")
                .d("选择后已编辑内容将被模板替换，请谨慎操作")
            )
          ),
        ]),
      ]),
      _c(
        "yxtbiz-range-selector",
        {
          attrs: { tabs: _vm.tabs, model: "array" },
          on: { change: _vm.handleTabsClick },
          model: {
            value: _vm.selectData,
            callback: function ($$v) {
              _vm.selectData = $$v
            },
            expression: "selectData",
          },
        },
        [
          _c(
            "div",
            { attrs: { slot: "customTab" }, slot: "customTab" },
            [
              _c("yxt-input", {
                staticClass: "yxtbiz-hwk-template-selector__search",
                attrs: {
                  size: "small",
                  placeholder: this.$t("pc_biz_survey_tip_namesearch").d(
                    "请输入模板名称搜索"
                  ),
                  searchable: "",
                  clearable: "",
                },
                on: {
                  search: function ($event) {
                    return _vm.searchData(true)
                  },
                  clear: function ($event) {
                    return _vm.searchData(true)
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    ) {
                      return null
                    }
                    return _vm.searchData(true)
                  },
                },
                model: {
                  value: _vm.keyword,
                  callback: function ($$v) {
                    _vm.keyword = typeof $$v === "string" ? $$v.trim() : $$v
                  },
                  expression: "keyword",
                },
              }),
              _c(
                "yxt-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  ref: "tableRefs",
                  staticClass: "yxtbiz-hwk-template-selector__table",
                  attrs: {
                    "row-key": _vm.getRowKey,
                    height: _vm.getHeight,
                    data: _vm.tableData,
                  },
                },
                [
                  _c("yxt-table-column", {
                    attrs: { width: "40" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("yxt-radio", {
                              attrs: { label: scope.row.id },
                              nativeOn: {
                                change: function ($event) {
                                  return _vm.getCurrentRow(scope.row)
                                },
                              },
                              model: {
                                value: _vm.resRadio,
                                callback: function ($$v) {
                                  _vm.resRadio = $$v
                                },
                                expression: "resRadio",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      width: "180",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("pc_biz_lbl_work_name").d("作业名称"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c(
                              "yxt-link",
                              {
                                staticClass:
                                  "yxtbiz-hwk-template-selector__name",
                                attrs: { type: "primary", underline: false },
                                on: {
                                  click: function ($event) {
                                    return _vm.linkName(row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n        " +
                                    _vm._s(row.templateName) +
                                    "\n      "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "220",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("pc_biz_work_require").d("作业要求"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.cleanStyle(row.requirement)) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("pc_biz_lbl_model").d("模式"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  _vm.$t(
                                    row.multiItem
                                      ? "pc_biz_lbl_row_model"
                                      : "pc_biz_lbl_signle_model"
                                  )
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "120",
                      "show-overflow-tooltip": "",
                      label: _vm.$t("pc_biz_o2o_updater").d("更新人"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _c("yxtbiz-user-name", {
                              attrs: { name: row.updateFullname || "--" },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("yxt-table-column", {
                    attrs: {
                      "min-width": "180",
                      "show-overflow-tooltip": "",
                      label: _vm
                        .$t("pc_biz_global_lbl_updateTime")
                        .d("更新时间"),
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (ref) {
                          var row = ref.row
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(
                                  row.updateTime
                                    ? _vm.dateFormat(row.updateTime)
                                    : "--"
                                ) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
              _c("yxt-pagination", {
                staticClass:
                  "pull-right mt16 yxtbiz-hwk-template-selector__page",
                attrs: {
                  layout: "total, prev, pager, next",
                  "current-page": _vm.page.current,
                  "page-size": _vm.page.limit,
                  total: _vm.page.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "yxt-button",
            { attrs: { plain: "" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("pc_biz_common_cancel_mini").d("取消")))]
          ),
          _c(
            "yxt-button",
            {
              attrs: { type: "primary", loading: _vm.dLoading },
              on: { click: _vm.handleSure },
            },
            [_vm._v(_vm._s(_vm.$t("pc_biz_common_btn_sure").d("确定")))]
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }